import { BaseService } from "./../base";
export class SepecialtyNodeService extends BaseService {
  static get entity() {
    return "specialty_node";
  }
  static get name() {
    return "specialty_node";
  }

  static async getByDestinationNode(node_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_node_id/${node_id}`, this.name);
  }

  static async filter(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter`, this.name, data);
  }
}
